import { render, staticRenderFns } from "./Yijing.vue?vue&type=template&id=102d3b12&scoped=true&"
import script from "./Yijing.vue?vue&type=script&lang=js&"
export * from "./Yijing.vue?vue&type=script&lang=js&"
import style0 from "./Yijing.vue?vue&type=style&index=0&id=102d3b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102d3b12",
  null
  
)

export default component.exports